import React, { FC } from 'react';

import { Separator } from 'components/ui/separator';

import { Spacing, SPACING_MAP } from '../FormFields.types';

interface IFormFieldsSectionProps {
  heading: string;
  description?: string;
  showSeparator?: boolean;
  separatorSpacing?: Spacing;
  spacing?: Spacing;
  headingBottomMargin?: boolean;
  children: React.ReactNode;
}

export const FormFieldsSection: FC<IFormFieldsSectionProps> = ({
  heading,
  description,
  showSeparator = false,
  separatorSpacing = 'md',
  spacing = 'none',
  headingBottomMargin = false,
  children
}): React.ReactElement => {
  const headingClass = `text-[20px] font-semibold text-zinc-900${!description && headingBottomMargin ? ' mb-6' : ''}`;

  return (
    <React.Fragment>
      {showSeparator && <Separator className={`${SPACING_MAP[separatorSpacing]} mb-9 bg-base-border`.trim()} />}
      <div className={SPACING_MAP[spacing]}>
        <h3 className={headingClass}>
          {heading}
        </h3>
        {description && (
          <p className="font-inter text-base font-normal text-base-mutedForeground mt-1.5 mb-6">
            {description}
          </p>
        )}
        {children}
      </div>
    </React.Fragment>
  );
};
